import { useUrlFilters } from "../../../shared/hooks/useUrlFilters";
var normalizeFilterValue = function (value) {
    return (Array.isArray(value) ? value : value ? [value] : []).filter(Boolean);
};
export function useDisque100Filters() {
    var _a = useUrlFilters(), clearFilters = _a.clearFilters, getMultiFilter = _a.getMultiFilter, setMultiFilter = _a.setMultiFilter, setMultiFilters = _a.setMultiFilters;
    var yearFilter = getMultiFilter("periodo");
    var semesterFilter = getMultiFilter("semestre");
    var handleFilterChange = function (key, value) {
        var nextValues = normalizeFilterValue(value);
        if (key === "periodo") {
            setMultiFilters({ periodo: nextValues, semestre: [] });
            return;
        }
        if (key === "semestre") {
            setMultiFilter("semestre", nextValues);
        }
    };
    return {
        yearFilter: yearFilter,
        semesterFilter: semesterFilter,
        values: {
            periodo: yearFilter,
            semestre: semesterFilter,
        },
        handleFilterChange: handleFilterChange,
        resetFilters: clearFilters,
    };
}
